/**
 * 导航跳转链接（个人中心分组卡内的一行）
 */

import React, { FC } from 'react';
import { RightArrow, Icon } from 'component/Icon/index';
import { statistic, StatisticCategory } from 'util/index';
import styles from './NavItem.module.scss';

interface Props {
    title: string;
    // title左侧的icon（自定义元素，优先级高于字体icon）
    titleIcon?: JSX.Element;
    // 也可以传内置的字体icon，只需要给icon的 css class
    titleIconName?: string;
    // 内置字体icon可以设置颜色
    titleIconStyle?: {
        color: string;
    };
    // 图标底色（圆角小方块底色），与全站卡片风格保持一致
    iconBg?: string;
    // 可选的右侧文字说明
    subText?: string | JSX.Element;
    onClick?: () => void;
    // 是否显示顶部分隔线（分组卡内第一行不显示）
    showTopBorder?: boolean;
}

export const NavItem: FC<Props> = function(props){
    // 右侧箭头左的文字
    let subTextCon = null;
    if (props.subText) {
        if (typeof props.subText === 'string' ) {
            subTextCon = (<span className={styles.subText}>{props.subText}</span>);
        } else {
            subTextCon = props.subText;
        }
    }
    // 文字左侧icon
    let iconEl = null;
    if (props.titleIcon) {
        iconEl = props.titleIcon;
    } else if(props.titleIconName) {
        const style = Object.assign({ fontSize: '17px' }, props.titleIconStyle);
        iconEl = (<Icon style={style} iconClassName={props.titleIconName} />);
    }
    function onClick() {
        props.onClick && props.onClick();
        statistic({
            category: StatisticCategory.UserCenter,
            action: `点击-${props.title}`,
        });
    }
    return (
        <div onClick={onClick} className={styles.item}>
            {props.showTopBorder !== false && <div className={styles.divider} />}
            <span className={styles.iconChip} style={props.iconBg ? { background: props.iconBg } : undefined}>
                {iconEl}
            </span>
            <span className={styles.title}>{props.title}</span>
            {subTextCon}
            {
                props.onClick && <RightArrow style={{fontSize: '18px', color: '#c8c8c8'}}/>
            }
        </div>
    );
};

interface TitleIconProps {
    iconClassName: string;
    iconStyle?: {
        color?: string;
    };
}
export function NavTitleIcon({iconClassName, iconStyle}: TitleIconProps) {
    const style = Object.assign({fontSize: '17px'}, iconStyle);
    return (
        <span style={{marginRight: '11px'}}>
            <Icon style={style} iconClassName={iconClassName} />
        </span>
    );
}
